export function numberMax() {

    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            ctrl.$validators.max = function (modelValue, viewValue) {

                if (parseInt(modelValue) > attrs.numberMax) {

                    return false;
                }

                return true;
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/number-max.directive.js